import React, {Component} from 'react';
import versionInfo from '../package.json';
import Cookies from 'universal-cookie';
import { isNullOrUndefined } from 'util';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import { enGB } from 'date-fns/esm/locale';
import {LanguageProvider} from './containers/Language';
import Root from './components/Root/Root';
import { clearCookiesStorageAndRedirect } from './common/utility/utility';
import userAccess from './common/const/rolesConfig.json';
import {refreshTokenApi, tokenApi, userClaimsApi, validateTokenApi} from './services/auth-api';
import groupnames from './common/const/groupnames';
import './App.css';
import envHelper from './common/env-helper';

const envObj=envHelper.setEnvironmentURLs();  
registerLocale("en-GB", enGB);
setDefaultLocale("en-GB");   

const cookies = new Cookies();
const appVersion = envObj.APP_VERSION + versionInfo.version;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputChange: false,
      readAccess: false,
      writeAccess: false,
      userId: '',
      prefLangCode: "1",
      isBusinessPartner: false,
      isNmbsUser: false,
      businessPartnerCode:'',
      refreshTokenTimeInterval: 1000 * 60 * 30, //30 minutes
      timeout: 1000 * 60 * 60, //60 minutes
     //  isLogout: false
    };
  }

  componentWillMount() {
    let getStateVal = localStorage.getItem('stateVal');
    if (getStateVal !== null && typeof(getStateVal) !== 'undefined') {
      this.startAuthentication();
    }
  }

  componentDidMount() {
    window.addEventListener('storage', e => {
      const getToken = cookies.get('token');
      if(e.key === 'stateVal' && e.oldValue && !e.newValue && isNullOrUndefined(getToken)) {
        clearCookiesStorageAndRedirect(false);
      }
    });
  }

  clearCookiesAndRedirect = () => {
    clearCookiesStorageAndRedirect(false);
  }

  startAuthentication = async () => {
    let getToken = cookies.get('token');
    let getStateVal = localStorage.getItem('stateVal');
    
    if (!isNullOrUndefined(getStateVal)) {
      
      if (!isNullOrUndefined(getToken)) {
       
        await validateTokenApi(getToken.token)
          .then(response => {
            const obj = response;
              
            if (obj.isError === false && obj.isActive === true) {
              this.userClaims();
            }
            else {
              this.clearCookiesAndRedirect();
            }
          })
          .catch(error => {
            this.clearCookiesAndRedirect();
          })
      }
      else {
       
        let codeVal1 = '';
        let codeVal2 = '';
        let stateVal = '';
        const authURL = window.location.href;
        let validateAuthUrl = localStorage.getItem('IsAuthURL');
      
        if ((authURL !== '' && authURL.indexOf('code=') > -1)
          && (validateAuthUrl === undefined || validateAuthUrl === null)) {
          localStorage.setItem("IsAuthURL", "yes");
          stateVal = authURL.split('&state=')[1];
          if (stateVal === getStateVal) {
            codeVal1 = authURL.split('&state=')[0];
            codeVal2 = codeVal1.split('code=')[1];
            if(codeVal2) {
              this.tokenApi(codeVal2);
            } else{
              this.clearCookiesAndRedirect();
            }
          }
          else {
            this.clearCookiesAndRedirect();
          }
        }
        else {
          this.clearCookiesAndRedirect();
        }
      }
    }
    else {
      this.clearCookiesAndRedirect();
    }
  }

  tokenApi = async (codeVal) => {
    if (codeVal) {
      await tokenApi(codeVal)  
        .then(response => {
          const obj = response;
          if (obj && obj.token) {
            cookies.set("token", obj, { path: '/', maxAge: obj.expiresIn, secure: true });
            window.location.reload();
          }
          else {
            this.clearCookiesAndRedirect();
          }
        })
        .catch(error => {
          this.clearCookiesAndRedirect();
        })
    }
    else {
      this.clearCookiesAndRedirect();
    }
  }

  userClaims = async () => {
    const cookieToken = cookies.get('token');
    
    if (!isNullOrUndefined(cookieToken)) {
      await userClaimsApi(cookieToken.token)
        .then(response => {
          const obj = response;
          const configBpGroup = groupnames.BUSINESS_PARTNER_GROUP_NAME;
          const configEmployeeGroup = groupnames.EMPLOYEE_GROUP_NAME;
          let isBusinessPartner=false;
          let isNmbsUser=false;
          let businessPartnerCode='';
          if(obj && obj.b_groups && obj.b_groups.length > 0) {
              isBusinessPartner = obj.b_groups.some(el=> configBpGroup.includes(el));
              isNmbsUser = !isBusinessPartner && obj.b_groups.some(el=> configEmployeeGroup.includes(el));

            if(isBusinessPartner) {
              const concessionNumbers = obj.b_groups.filter(el=>!configBpGroup.includes(el))
              businessPartnerCode=concessionNumbers && concessionNumbers.length > 0 ? concessionNumbers[0]: "";
            }

            if(isBusinessPartner || isNmbsUser) {
                let accessArr = [];
                let userRoles = obj.role;
                let userid = obj.sub;
                if (!isNullOrUndefined(userRoles) && userRoles.length > 0) {
                  userAccess.forEach((accessObj) => {
                    userRoles.forEach((rolesObj) => {
                      if (accessObj.Role === rolesObj) {
                        accessArr.push(accessObj);
                      }
                    });
                  });
                } else {
                  this.clearCookiesAndRedirect();
                }
                let prefLangCode = "1";
                if (obj.pLan) {
                  let key1 = obj.pLan.toLowerCase().split("-");
                  if (key1[0] === 'en' || obj.pLan === 'E') {
                    prefLangCode = "1";
                  }
                  else if (key1[0] === 'fr' || obj.pLan === 'F') {
                    prefLangCode = "2";
                  }
                  else if (key1[0] === 'nl' || obj.pLan === 'N') {
                    prefLangCode = "3";
                  }
                  else if (key1[0] === 'de' || obj.pLan === 'D') {
                    prefLangCode = "4";
                  }
                }
                let readAccessArray = [];
                let writeAccessArray = [];
                if (!isNullOrUndefined(accessArr) && accessArr.length > 0) {
                  accessArr.forEach((obj1) => {
                    readAccessArray.push(obj1.Read);
                    writeAccessArray.push(obj1.Update);
                  });
                }
                let readAccessKey = '';
                let writeAccessKey = '';
                let readAccessBool = false;
                let writeAccessBool = false;
                readAccessKey = readAccessArray.find(keyR => keyR === 'Y');
                writeAccessKey = writeAccessArray.find(keyW => keyW === 'Y');
                readAccessBool = readAccessKey === 'Y' ? true : false;
                writeAccessBool = writeAccessKey === 'Y' ? true : false;
                this.setState({
                  readAccess: readAccessBool,
                  writeAccess: writeAccessBool,
                  prefLangCode: prefLangCode,
                  userId: userid,
                  isBusinessPartner: isBusinessPartner,
                  isNmbsUser: isNmbsUser,
                  businessPartnerCode: businessPartnerCode
                });
            } else {
                this.clearCookiesAndRedirect();
            }    
          } else {
            this.clearCookiesAndRedirect();
          }
        })
        .catch(error => {
          this.clearCookiesAndRedirect();
        })
    }
    else {
      this.clearCookiesAndRedirect();
    }

    const isAuth = (!isNullOrUndefined(this.state.userId) && this.state.userId.trim() !== "" && (this.state.isBusinessPartner || this.state.isNmbsUser));
    localStorage.setItem('isAuth', isAuth);
    localStorage.setItem('isLoading', false);
  }

  validateToken = async () => {
      const cookieToken = cookies.get('token');
      if (!isNullOrUndefined(cookieToken)) {
        await validateTokenApi(cookieToken.token)
          .then(response => {
            const obj = response;
            if (obj && obj.isError === false && obj.isActive === true) {
              this.refreshToken();
            }
            else {
              this.clearCookiesAndRedirect()
            }
          })
          .catch(error => {
            this.clearCookiesAndRedirect();
          })
      }
      else {
        this.clearCookiesAndRedirect();
      }
  }

  refreshToken = async () => {
      const cookieToken = cookies.get('token');
      // storing refreshToken in session as we were getting null value in next call
      if (!isNullOrUndefined(cookieToken.refreshToken)) {  
      localStorage.setItem('rftValue',cookieToken.refreshToken)
      }
      const refreshTokenValue = localStorage.getItem('rftValue');
    
      if (!isNullOrUndefined(cookieToken) 
      && (!isNullOrUndefined(refreshTokenValue))) {
      await refreshTokenApi(cookieToken.token, refreshTokenValue)
            .then(response => {
              const obj = response;
              if (obj && isNullOrUndefined(obj.error)) {
                cookies.remove('token', { path: '/' });
                cookies.set("token", obj, { path: '/', maxAge: obj.expiresIn });
              }
              else {
                this.clearCookiesAndRedirect();
              }
            })
            .catch(error => {
              this.clearCookiesAndRedirect();
            })
      }
      else {
        this.clearCookiesAndRedirect();
      }
  }

  setIsLoading = (loading) => {
      localStorage.setItem('isLoading', loading);
  }
  
  render() {
    const isToken = cookies.get("token") && cookies.get("token") !== null;
    const userId = this.state.userId;
    const isAuthenticate =(isToken && userId && userId.trim() !==""); 
    const isBusinessPartnerUser = isAuthenticate && this.state.isBusinessPartner && this.state.businessPartnerCode && this.state.businessPartnerCode.trim() !=="";
    const isNmbsuser = isAuthenticate && this.state.isNmbsUser && (this.state.writeAccess || this.state.readAccess);
    return (
         <LanguageProvider isAuthenticate={isAuthenticate} prefLangCode={this.state.prefLangCode}>
             <Root appVersion={appVersion}
                 businessPartnerCode={this.state.businessPartnerCode}
                 isAuthenticate={isAuthenticate}
                 isBusinessPartnerUser={isBusinessPartnerUser}
                 isEditAccess={this.state.writeAccess}
                 isNmbsUser={isNmbsuser}
                 setIsLoading={this.setIsLoading}
                 userId={userId}
                 clearSessionData={() => this.clearCookiesAndRedirect()}
             />
         </LanguageProvider>
    );
  }
}

export default App;